
<template>
    <div class="water-academia">
    	<span class="water-academia__title">
    		SU AKADEMİSİ
    	</span>
		<div class="water-academia__text">
			Su’ya dair Bilimsel <br>
			İçerik Portalı
		</div>
		<router-link to="/su-akademisi" class="water-academia__button">
			<i class="water-academia__button-icon">
				<svg viewBox="0 0 39 22">
					<path fill="#FFF" d="M37.992 8.94l-1.166.458v4.944c-.177.292-.38.439-.612.44-.23 0-.463-.146-.696-.439V9.912l-3.923 1.538v7.651c-.044 1.018-.783 1.876-1.795 2.082-3.33.555-6.7.83-10.077.817-5.2 0-8.642-.44-10.535-.781-1.012-.224-1.746-1.093-1.785-2.118v-7.65L1.006 8.941C-.33 8.418-.336 7.546.993 7.005l16.205-6.6c.766-.281 1.58-.418 2.4-.404.83-.014 1.653.126 2.43.413l15.98 6.58c1.33.547 1.321 1.423-.016 1.947zM36.238 20.62c-1.156 0-2.093-.826-2.093-1.845 0-.68.698-1.854 2.093-3.523 1.395 1.67 2.092 2.843 2.092 3.523 0 1.019-.937 1.845-2.092 1.845zm-5.95-8.656L21.93 15.24c-.78.274-1.602.408-2.431.394-.827.014-1.651-.12-2.43-.394L8.71 11.963V19.1c.041.4.324.735.713.85 1.917.345 5.262.758 10.3.758 3.3.013 6.596-.253 9.85-.797.386-.096.67-.42.714-.81v-7.14z"/>
				</svg>
			</i>
			<span class="water-academia__button-text">AKADEMİ'YE GÖZ AT</span>
		</router-link>
    </div>
</template>

<script>
    export default {
        name: "WaterAcademia",
        props: [],
    }
</script>

<style lang="scss">
    .water-academia {
    	display: flex;
        width: 263px;
        height: 202px;
        margin-left: 70px;
        flex-direction: column;
        overflow: hidden;
        justify-content: center;
        align-items: center;

        @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
            width: 550px;
            height: 350px;
        }

        &__title,
        &__text {
			font-size: 20px;
			font-weight: normal;
			font-stretch: normal;
			font-style: normal;
			line-height: normal;
			letter-spacing: normal;
			text-align: center;
			color: #ffffff;

			@media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                font-size: 45px;
            }
        }

        &__title {
        	font-weight: bold;
        }

        &__button {
			display: flex;
			width: 233px;
			height: 44px;
			border-radius: 27px;
			border: solid 1px #00bfed;
			background-color: #00bfed;
			justify-content: center;
			align-items: center;
			text-decoration: none;
			margin-top: 26px;

			@media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
	            width: 100%;
	            height: 100px;
				border-radius: 50px;
	        }

        	&-icon {
        		width: 40px;
        		margin-right: 20px;

        		@media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
		            width: 70px;
		        }
        	}

        	&-text {
				font-size: 12px;
				font-weight: bold;
				font-stretch: normal;
				font-style: normal;
				line-height: normal;
				letter-spacing: normal;
				color: #ffffff;

				@media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
		            font-size: 35px;
		        }
        	}
		}
		
		@media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
            margin-top: 80px;
            margin-left: 0px;
        }
    }
</style>